import { useRoutes, Navigate } from 'react-router-dom'
import App from '../App'
import CreateWallet from '@/views/CreateWallet'
import Bot from '@/views/MarKetBot'
import Collect from '@/views/Collect'
import SenderToken from '@/views/SenderToken'
import RPCListPage from '@/views/RPCListPage'
import FrontrunBot from '@/views/FrontrunBot'


const routers = () => {
  const router = useRoutes([
    {
      path: '/',
      element: <App />,
      children: [
        { index: true, element: <Navigate to='marketbot' /> },

        { path: 'createwallet', element: <CreateWallet /> },
        { path: 'sendertoken', element: <SenderToken /> },
        { path: 'collect', element: <Collect /> },
        { path: 'marketbot', element: <Bot /> },
        // { path: 'rpclist', element: <RPCListPage /> },
        // { path: 'frontrunbot', element: <FrontrunBot /> },

      ]
    },
  ])
  return router
}

export default routers